import React from "react";
import { Modal } from "../../../SharedComponents";
import { ModalNames } from "../../../../Constants/modalNames";
import { useModal } from "../../../../Store/modules/modal/modal";

export const PreviewModal: React.FC = () => {
  const { modalProps } = useModal();
  const { file } = modalProps || {};

  const isOfficeProduct =
    file?.file_path?.includes(".csv") ||
    file?.file_path?.includes(".xls") ||
    file?.file_path?.includes(".xlsx") ||
    file?.file_path?.includes(".ppt") ||
    file?.file_path?.includes(".pptx") ||
    file?.file_path?.includes(".docx") ||
    file?.file_path?.includes(".doc");

  const isImage =
    file?.file_path?.includes(".jpeg") ||
    file?.file_path?.includes(".jpg") ||
    file?.file_path?.includes(".svg") ||
    file?.file_path?.includes(".png");

  return (
    <Modal
      modalName={ModalNames.PreviewModal}
      modalClassName="xs:w-[300px] md:w-[600px] md:h-[600px] xs:h-[400px] rounded-[5px]"
    >
      <div className=" flex justify-center items-center h-full">
        {isOfficeProduct ? (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${file?.file_path}`}
            title="office-product"
            className="w-full h-full"
          />
        ) : null}
        {file?.file_path.includes(".pdf") ? (
          <iframe className="w-full h-full" title="pdf" src={file?.file_path} />
        ) : null}
        {isImage ? <img src={file?.file_path} className="w-full h-full" alt="preview-img" /> : null}
      </div>
    </Modal>
  );
};
